module.exports = __webpack_public_path__ + "static/media/20ECE17.2a9bfbc1.jpg";